import Dashboard from "./Dashboard";
const dashboard={
     Dashboard
}
export default dashboard